module.exports = "/assets/a5e358e092eb4bb688c3d218f4786d9d.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/SK.png
// module id = 1824
// module chunks = 0